export default __webpack_public_path__ + "assets/images/7b5839dcdc4becd9d4fbb70af53445fb.jpg";